import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import PageTransition from '../components/PageTransition';
import { ABOUT_PAGE, NAVBAR_CTA, SITE_CONFIG } from '../data';
import './AboutPage.css';

export default function AboutPage() {
  const d = ABOUT_PAGE;
  return (
    <PageTransition>
      <div className="about-page">

        {/* Hero */}
        <section className="page-hero">
          <div className="page-hero-bg" />
          <div className="container page-hero-content">
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
              <span className="section-tag">{d.hero.tag}</span>
              <h1>{d.hero.title}</h1>
              <p>{d.hero.description}</p>
            </motion.div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="mission-section">
          <div className="container">
            <div className="mission-grid">
              {[d.mission, d.vision].map((item, i) => (
                <motion.div
                  key={item.title}
                  className="mission-card"
                  initial={{ opacity: 0, x: i === 0 ? -30 : 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                >
                  <div className="mission-icon">{item.icon}</div>
                  <h2>{item.title}</h2>
                  <p>{item.text}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="values-section">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">{d.valuesSectionTag}</span>
              <h2 className="section-title">{d.valuesSectionTitle}</h2>
            </div>
            <div className="values-grid">
              {d.values.map((v, i) => (
                <motion.div
                  key={v.title}
                  className="value-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 }}
                >
                  <span className="value-icon">{v.icon}</span>
                  <h3>{v.title}</h3>
                  <p>{v.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Timeline */}
        <section className="timeline-section">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">{d.timelineSectionTag}</span>
              <h2 className="section-title">{d.timelineSectionTitle}</h2>
            </div>
            <div className="timeline">
              {d.timeline.map((item, i) => (
                <motion.div
                  key={item.year}
                  className="timeline-item"
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.15 }}
                >
                  <div className="timeline-year">{item.year}</div>
                  <div className="timeline-connector">
                    <div className="timeline-dot" />
                    {i < d.timeline.length - 1 && <div className="timeline-line" />}
                  </div>
                  <div className="timeline-content">
                    <h3>{item.title}</h3>
                    <p>{item.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="about-cta">
          <div className="container">
            <div className="about-cta-inner">
              <h2>{d.ctaTitle}</h2>
              <p>{d.ctaDescription}</p>
              <Link to={NAVBAR_CTA.path} className="btn-primary">
                {d.ctaBtnLabel}
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="15" height="15"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </Link>
            </div>
          </div>
        </section>

      </div>
    </PageTransition>
  );
}
